import { ROUTE_CONSTANT } from '@libs/constants';
import h from '../helpers/common';

type ProgramType = 'movie' | 'series|episode' | 'movie|series|episode';
type Category = 'movie' | 'series' | 'all';

interface EpisodeDetails {
    episodeId: string;
    episodeGuid: string;
    title: string;
    titleLocalized: Record<string, string>;
    description: string;
    duration?: number;
    episodeNumber?: number;
    seasonNumber?: number;
    seasonId?: string;
}

export interface ContentItem {
    Id: string;
    categories: string[];
    category: string;
    description: string;
    descriptionEn: string;
    duration?: number;
    episodeDetails?: EpisodeDetails;
    genre: string[];
    guid: string;
    image: string;
    image_landscape: string;
    introEt?: number;
    introSt?: number;
    isLocked: boolean;
    language: string;
    mediaId: string | null;
    name: string;
    outroEt?: number;
    outroSt?: number;
    programType: string;
    promoType: boolean;
    provider: string[];
    ratings: string;
    seriesId?: string;
    streamingUrl: string | null;
    subscriptionGuids: string[];
    tags: Record<string, any>[];
    text: string;
    textEn: string;
    timeCode: number;
    trailer: string | null;
    trailerMediaUrl: string | null;
    tvSeasonEpisodeNumber: number;
    tvSeasonId?: string;
    tvSeasonNumber: number;
    vodTrailer: string | null;
    year: number;
}

const routeFilter = {
    [ROUTE_CONSTANT.MOVIES]: 'movie',
    [ROUTE_CONSTANT.SHOWS]: 'series|episode',
} as const;

// This hook is used to determine the program type and category for the continue watching carousel
export function useContinueWatchingFilters() {
    const currentScreen = h.getScreen().toLowerCase();
    const programType: ProgramType = routeFilter[currentScreen] || 'movie|series|episode';
    const category: Category = routeFilter[currentScreen] || 'all';

    return {
        programType,
        category,
    };
}
